import { cn } from "@/lib/utils";

const STYLES = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
  suspended: "bg-rose-50 text-rose-700 border-rose-200",
  pending_verification: "bg-amber-50 text-amber-700 border-amber-200",
  operational: "bg-emerald-50 text-emerald-700 border-emerald-200",
  degraded: "bg-amber-50 text-amber-700 border-amber-200",
  not_configured: "bg-slate-100 text-slate-500 border-slate-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  error: "bg-rose-50 text-rose-700 border-rose-200",
  info: "bg-blue-50 text-[#101876] border-blue-200",
  default: "bg-slate-100 text-slate-600 border-slate-200",
};

const LABELS = {
  pending_verification: "Pending",
  not_configured: "Not configured",
};

export function StatusBadge({ status, className = "" }) {
  const style = STYLES[status] || STYLES.default;
  const label = LABELS[status] || (status ? status.replace(/_/g, " ") : "—");
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider",
        style,
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {label}
    </span>
  );
}
